import { Box, Flex, HStack, Text } from '@skin-seoul/design-system';
import JewelIcon from './Jewel';
export const SkinSeoulHiddenGems = () => {
  return <Flex alignItems="center" justifyContent="center" width="100%" height="fit-content" background="linear-gradient(180deg, rgba(111, 63, 215, 0.00) 0%, rgba(111, 63, 215, 0.40) 100%);" paddingTop="20px" paddingBottom="8px" data-sentry-element="Flex" data-sentry-component="SkinSeoulHiddenGems" data-sentry-source-file="SkinSeoulHiddenGems.tsx">
      <HStack gap="8px" alignItems="center" height="100%" data-sentry-element="HStack" data-sentry-source-file="SkinSeoulHiddenGems.tsx">
        <Box width="20px" height="20px" display="flex" alignItems="center" justifyContent="center" data-sentry-element="Box" data-sentry-source-file="SkinSeoulHiddenGems.tsx">
          <JewelIcon data-sentry-element="JewelIcon" data-sentry-source-file="SkinSeoulHiddenGems.tsx" />
        </Box>

        <Text textStyle="label.small" fontWeight="normal" color="primary.500" whiteSpace="nowrap" data-sentry-element="Text" data-sentry-source-file="SkinSeoulHiddenGems.tsx">
          Hidden Gems
        </Text>
      </HStack>
    </Flex>;
};
export default SkinSeoulHiddenGems;